import React from "react";
import { IconButton, useMediaQuery } from "@mui/material";
import icon_information from "assets/images/icon_information.svg";

const HomeCurvedText = (props) => {
  const matches = useMediaQuery("(max-width:500px)");
  // const matches = useMediaQuery(theme.breakpoints.down("md"));
  const {
    // dimensions = "M0 40, Q70 20, 140 40",
    dimensions = "M0,40 Q70,20 140,40",
    title,
    left,
    top,
    degree,
    bottom,
    right,
    fontSize = 26,
    fontFamily = matches ? "Lato-Semibold" : "Lato-Regular",
    titleColor = "#051a28",
    textStartPoint = 30,
    textEndPoint = 50,
    showSecondCurve,
    secondCurveTitle,
    secondCurveLeft,
    secondCurveTop,
    secondCurveDegree,
    secondCurveBottom,
    secondCurveRight,
    secondCurveFontSize = 26,
    secondCurveTextStartPoint = 30,
    secondCurveTextEndPoint = 50,
    secondTitleColor = "#fff",
    secondTitleFontFamily = matches ? "Lato-Semibold" : "Lato-Regular",
    unicode,
    showInfoICon,
    onButtonClick,
    showDagger,
  } = props;
  return (
    <>
      {showSecondCurve ? (
        <span
          style={{
            position: "absolute",
            left: secondCurveLeft,
            top: secondCurveTop,
            right: secondCurveRight,
            bottom: secondCurveBottom,
            zIndex: 10,
            height: 60,
            width: matches ? 92 : 130,
            transform: `rotate(${secondCurveDegree}deg)`,
          }}
        >
          <div
            style={{
              display: "inline-block",
              width: matches ? 92 : 130,
              height: matches ? 90 : 60,
              position: "relative",
            }}
          >
            <svg id="mysvg1" viewBox="0 0 140 60" preserveAspectRatio="xMidYMid meet">
              <path id={secondCurveTitle} d={dimensions} fill="none" stroke="none" />
              <text
                x={secondCurveTextStartPoint}
                y={secondCurveTextEndPoint}
                dominantBaseline="top"
              >
                <textPath
                  xlinkHref={`#${secondCurveTitle}`}
                  style={{
                    fontSize: secondCurveFontSize,
                    fill: secondTitleColor,
                    fontFamily: secondTitleFontFamily,
                  }}
                >
                  {secondCurveTitle}
                </textPath>
              </text>
            </svg>
          </div>
        </span>
      ) : (
        ""
      )}
      <span
        style={{
          position: "absolute",
          left: left,
          top: top,
          right: right,
          bottom: bottom,
          zIndex: 10,
          height: 60,
          width: matches ? 92 : 130,
          transform: `rotate(${degree}deg)`,
        }}
      >
        <div
          style={{
            display: "inline-block",
            width: matches ? 92 : 130,
            height: matches ? 90 : 60,
            position: "relative",
          }}
        >
          <svg
            id="mysvg2"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 140 60"
            preserveAspectRatio="xMidYMid meet">
            <defs>
              <path id={title} d={dimensions} fill="black" stroke="#000" />
            </defs>
            <text x={textStartPoint} y={textEndPoint} dominantBaseline="top">
              <textPath
                xlinkHref={`#${title}`}
                style={{
                  fontSize: fontSize,
                  fill: titleColor,
                  fontFamily: fontFamily,
                }}
              >
                {title}
              </textPath>
            </text>
          </svg>
          {showInfoICon ? (
            <IconButton
              onClick={() => onButtonClick()}
              sx={{ position: "absolute", right: 0, top: "5px" }}
            >
              {/* <InfoOutlinedIcon
                sx={{ color: "white", backgroundColor: "#11952A", borderRadius: "50%" }}
              /> */}
              <img src={icon_information} alt="i" />
            </IconButton>
          ) : null}
          {showDagger ? (
            <b
              style={{
                position: "absolute",
                right: "18px",
                fontSize: "10px",
                top: "15px",
                transform: "rotate(10deg)",
              }}
            >
              {unicode}
            </b>
          ) : null}
        </div>
      </span>
    </>
  );
};

export default HomeCurvedText;
